import { render, staticRenderFns } from "./ForwardEmailModal.vue?vue&type=template&id=40c8e466&scoped=true"
import script from "./ForwardEmailModal.vue?vue&type=script&lang=js"
export * from "./ForwardEmailModal.vue?vue&type=script&lang=js"
import style0 from "./ForwardEmailModal.vue?vue&type=style&index=0&id=40c8e466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c8e466",
  null
  
)

export default component.exports